import { all } from "redux-saga/effects";
import orgSaga from "./organizations/orgSaga";
import userSaga from "./user/userSaga";
import subscriptionSaga from "./subscription/subscriptionSaga";

export default function* rootSaga() {
  yield all([userSaga(), orgSaga(), subscriptionSaga()]);
}
